export default "__VITE_ASSET__BwRtjmFE__"